import { defineMessages } from 'react-intl';

// Query type identifiers for batch data fetching in PortfolioShow. Produced by
// `BatchQueryError` in `dataBatching.js` and surfaced to the consumer via
// `usePortfolioData` so the fallback UI can render a query-specific message.
// The helper is feature-agnostic and each feature supplies its own `messages`.

export const PORTFOLIO_SHOW_QUERY_TYPES = Object.freeze({
  METERS: 'metersQuery',
  RULES: 'rulesQuery',
  METER_DATA: 'meterDataQuery',
  TRADE_SET_SUMMARY: 'tradeSetSummaryQuery',
});

export const messages = defineMessages({
  [PORTFOLIO_SHOW_QUERY_TYPES.METERS]: {
    id: 'portfolio.portfolio_show.helpers.error_modal.meters_query.body.message',
    defaultMessage: 'An error occurred while loading meters. Please try again.',
  },
  [PORTFOLIO_SHOW_QUERY_TYPES.RULES]: {
    id: 'portfolio.portfolio_show.helpers.error_modal.rules_query.body.message',
    defaultMessage: 'An error occurred while loading rules. Please try again.',
  },
  [PORTFOLIO_SHOW_QUERY_TYPES.METER_DATA]: {
    id: 'portfolio.portfolio_show.helpers.error_modal.meter_data_query.body.message',
    defaultMessage: 'An error occurred while loading meter data. Please try again.',
  },
  [PORTFOLIO_SHOW_QUERY_TYPES.TRADE_SET_SUMMARY]: {
    id: 'portfolio.portfolio_show.helpers.error_modal.trade_set_summary_query.body.message',
    defaultMessage: 'An error occurred while loading trade set summaries. Please try again.',
  },
});
